import React, { forwardRef } from 'react';
import classNames from 'classnames/bind';
import { Widget, TooltipPosition, SortableWidgetProps } from '@creditsights/styleguide-web';
import { RecommendationDto } from '../../../../services/dtos/issuer/recommendation.dto';
import WeightIcon from '../../../WeightIcon';
import InfoButton from '../../common/InfoButton';
import CSViewCompanyPrintWidget from '../CSViewCompanyPrintWidget';
import styles from './CSViewCompanyWidget.module.scss';
import CSViewWidgetContent from '../CSViewWidgetContent';

const cx = classNames.bind(styles);

interface CSViewCompanyWidgetProps extends SortableWidgetProps {
  issuerTag: string;
  print?: boolean;
  recommendation?: RecommendationDto;
}

const CSViewCompanyWidget = (
  { issuerTag, print, recommendation, ...sortableWidgetProps }: CSViewCompanyWidgetProps,
  ref
): React.ReactElement => {
  const { isDragged } = sortableWidgetProps;
  const header = (
    <div className={cx('heading')}>
      CS View
      {!isDragged && <InfoButton tooltipPosition={TooltipPosition.TopCenter} />}
    </div>
  );

  if (print) {
    return <CSViewCompanyPrintWidget issuerTag={issuerTag} companyRecommendation={recommendation} />;
  }

  return (
    <Widget
      headerTitle={header}
      dataTestId="cs-view-company"
      firstLine={recommendation?.weighting ? <WeightIcon weighting={recommendation.weighting} /> : undefined}
      ref={ref}
      {...sortableWidgetProps}
    >
      <CSViewWidgetContent
        data={recommendation}
        issuerTag={issuerTag}
        showLinkToCompany={false}
        truncateContent={false}
      />
    </Widget>
  );
};

export default forwardRef(CSViewCompanyWidget);
